import { Avatar, Box } from "@mui/material"
import { ContainerStyled } from "./styles"
import { LinkStyled, NormalText, TitleStyled } from "../../shared/styles"
import { Button } from "../../shared/button/button"
import { useState } from "react"
import { ModalChangePassword } from "./modal-change-password"
import { ModalChangeEmail } from "./modal-change-email"
import { useGetUser } from "../../hooks/useGetUser"
import { Loader } from "../../shared/loader/loader"
import { CredentialsContainer } from "./credentials-container"
import { AuthenticatorContainer } from "./authenticator-container"
import { DividerStyled } from "../../shared/divider/divider"

export const ProfileContainer = () => {
  const [showModals, setShowModals] = useState({
    changePassword: false,
    changeEmail: false,
    editProfile: false,
  })

  const { user, isLoadingUser, credentials, isLoadingCredentials } =
    useGetUser()

  const handleShowModals = (modal) => {
    setShowModals((prev) => ({ ...prev, [modal]: !prev[modal] }))
  }

  return isLoadingUser ? (
    <Loader />
  ) : (
    <>
      <ModalChangePassword
        open={showModals?.changePassword}
        handleClose={() => handleShowModals("changePassword")}
      />
      <ModalChangeEmail
        open={showModals?.changeEmail}
        handleClose={() => handleShowModals("changeEmail")}
      />
      <ContainerStyled>
        <LinkStyled
          href="https://forms.gle/LbK6ofRekidJtqFZA"
          underline="none"
          target="_blank"
          sx={{
            position: "absolute",
            right: "24px",
            top: "24px",
            background: "#0197f6",
            padding: "4px 8px",
            borderRadius: "4px",
            color: "#F7F7F7",
            "&:hover": {
              color: "#0F110C",
            },
          }}
        >
          Give feedback
        </LinkStyled>
        <img
          src={"/bg-profile.jpg"}
          alt="Descripción de la imagen"
          height={"200px"}
          style={{
            width: "100%",
            objectFit: "cover",
            objectPosition: "center bottom", // <-- Esto alinea la imagen hacia abajo
            borderRadius: "8px 8px 0 0",
          }}
        />
        <Box
          display={"flex"}
          gap={"8px"}
          flexDirection={"column"}
          mt={"-80px"}
          mx={"24px"}
        >
          <Avatar
            src={user?.imagen}
            sx={{
              bgcolor: "#1976d2",
              border: "4px solid #F7F7F7",
              transition: ".2s",
              width: "100px",
              height: "100px",
            }}
          >
            {user?.usuario?.charAt(0)}
          </Avatar>
          <TitleStyled
            sx={{
              fontSize: "24px",
            }}
          >
            {user?.email}
          </TitleStyled>
          <Box display={"flex"} gap={"4px"} flexDirection={"column"}>
            <NormalText>
              {user?.nombre} {user?.apellido}
            </NormalText>
            <NormalText>{user?.domicilio}</NormalText>
          </Box>
          <Box display={"flex"} gap={"8px"}>
            <Button
              label={"Edit profile"}
              onClick={() => handleShowModals("editProfile")}
              isDisabled={true}
              tooltipLabel={"This feature is not available yet"}
            />
            <Button
              label={"Change password"}
              onClick={() => handleShowModals("changePassword")}
            />
            <Button
              label={"Change email"}
              onClick={() => handleShowModals("changeEmail")}
            />
          </Box>
          <DividerStyled />
          <AuthenticatorContainer />
          <DividerStyled />
          {isLoadingCredentials ? (
            <Loader />
          ) : credentials ? (
            <CredentialsContainer credentials={credentials} />
          ) : (
            <NormalText>
              No credentials found, please contact support
            </NormalText>
          )}
        </Box>
      </ContainerStyled>
    </>
  )
}
